var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"ripple",rawName:"v-ripple",value:({ color: '#333542' }),expression:"{ color: '#333542' }"}],staticClass:"button",class:{ loading: _vm.loadStatus },attrs:{"type":"submit"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }